import { getData, postData } from '@/views/mped/services/mped-service';

export function getYearsList(currentYear, negYears, posYears) {
    const years = [];
    for (let i = -negYears; i <= posYears; i++) {
        years.push(currentYear + i);
    }
    return years;
}

export const monthsList = [
    { id: 1, name: 'Январь', shortName: 'Я' },
    { id: 2, name: 'Февраль', shortName: 'Ф' },
    { id: 3, name: 'Март', shortName: 'Мр' },
    { id: 4, name: 'Апрель', shortName: 'Ап' },
    { id: 5, name: 'Май', shortName: 'Мй' },
    { id: 6, name: 'Июнь', shortName: 'Ин' },
    { id: 7, name: 'Июль', shortName: 'Ил' },
    { id: 8, name: 'Август', shortName: 'Ав' },
    { id: 9, name: 'Сентябрь', shortName: 'С' },
    { id: 10, name: 'Октябрь', shortName: 'О' },
    { id: 11, name: 'Ноябрь', shortName: 'Н' },
    { id: 12, name: 'Декабрь', shortName: 'Д' }
]

export const viewModeList = [
  {
    id: '0',
    name: 'Осн.деят.',
  }, {
    id: '1',
    name: 'Неосн.деят.',
  }, {
    id: '2',
    name: 'Прибыль',
  }];

export async function getEstimateColumns({ viewMode, notMainTypes, period }) {
    return ((!viewMode || viewMode === '0') && costEstimateColumnsMain)
      || (viewMode === '1' && !notMainTypes && costEstimateColumnsNotMain)
      || (viewMode === '1' && notMainTypes && [...costEstimateColumnsNotMain, ...await costEstimateColumnsNotMainAll({ period })])
      || (viewMode === '2' && costEstimateColumnsProfit);
}

export const costEstimateColumnsMain = [{
        dataField: 'sum_ee',
        caption: 'Сумма по Э/Э',
        dataType: 'number',
        width: '150px',
        format: '###,###,###,###,##0'
    }, {
        dataField: 'sum_te',
        caption: 'Сумма по Т/Э',
        dataType: 'number',
        width: '150px',
        format: '###,###,###,###,##0',
        allowEditing: false
    }, {
        dataField: 'sum_all',
        caption: 'Общая сумма',
        width: '150px',
        dataType: 'number',
        format: '###,###,###,###,##0'
    }, {
        dataField: 'otklon',
        caption: 'Отклонение',
        width: '150px',
        dataType: 'number',
        format: '###,###,###,###,##0',
        allowEditing: false
    }, {
        dataField: 'prizn',
        caption: 'Неосновная деят-ть',
        dataType: 'boolean',
        width: '150px',
        visible: false,
        allowEditing: false,
    }, {
        dataField: 'rsh_dh',
        caption: 'Расход',
        dataType: 'boolean',
        width: '150px',
        visible: false,
        allowEditing: false,
    }, {
        dataField: 'other',
        caption: 'Прочие',
        dataType: 'boolean',
        width: '150px',
        visible: false,
        allowEditing: false,
    }
];

export const costEstimateColumnsNotMain = [{
        dataField: 'sum_all',
        caption: 'Общая сумма',
        dataType: 'number',
        width: '150px',
        format: '###,###,###,###,##0'
    }, {
        dataField: 'otklon',
        caption: 'Отклонение',
        width: '150px',
        dataType: 'number',
        format: '###,###,###,###,##0',
        visible: false,
    }, {
        dataField: 'sum_nd',
        caption: 'Сумма по видам НД',
        width: '170px',
        dataType: 'number',
        format: '###,###,###,###,##0',
        allowEditing: false,
    }, {
        dataField: 'otklon_vd',
        caption: 'Откл.по видам',
        width: '140px',
        dataType: 'number',
        format: '###,###,###,###,##0',
        allowEditing: false,
    }, {
        dataField: 'otklon_itog',
        caption: 'Итого откл.',
        dataType: 'number',
        width: '120px',
        format: '###,###,###,###,##0',
        allowEditing: false,
    }, {
        dataField: 'prizn',
        caption: 'Неосновная деят-ть',
        dataType: 'boolean',
        width: '180px',
        visible: false,
        allowEditing: false,
    }, {
        dataField: 'rsh_dh',
        caption: 'Расход',
        dataType: 'boolean',
        width: '150px',
        visible: false,
        allowEditing: false,
    }, {
        dataField: 'other',
        caption: 'Прочие',
        dataType: 'boolean',
        width: '150px',
        visible: false,
        allowEditing: false,
    }
];

export const costEstimateColumnsProfit = [{
        dataField: 'sum_ee',
        caption: 'Сумма по Э/Э',
        dataType: 'number',
        width: '150px',
        format: '###,###,###,###,##0',
    }, {
        dataField: 'sum_te',
        caption: 'Сумма по Т/Э',
        dataType: 'number',
        width: '150px',
        format: '###,###,###,###,##0',
        allowEditing: false
    }, {
        dataField: 'sum_all',
        caption: 'Общая сумма',
        dataType: 'number',
        width: '150px',
        format: '###,###,###,###,##0',
    }, {
        dataField: 'otklon',
        caption: 'Ошибка ввода',
        dataType: 'number',
        visible: true,
        width: '150px',
        format: '###,###,###,###,##0',
        allowEditing: false
    }, {
        dataField: 'prizn',
        caption: 'Неосновная деят-ть',
        dataType: 'boolean',
        width: '150px',
        visible: false,
        allowEditing: false,
    }, {
        dataField: 'rsh_dh',
        caption: 'Расход',
        dataType: 'boolean',
        width: '150px',
        visible: false,
        allowEditing: false,
    }, {
        dataField: 'other',
        caption: 'Прочие',
        dataType: 'boolean',
        width: '150px',
        visible: false,
        allowEditing: false,
    }
];

const monthColumns = monthsList.map(x => {
    return {
        dataField: 'sum_' + x.id,
        caption: x.name,
        dataType: 'number',
        width: '100px',
        format: '###,###,###,###,##0',
    }
});

export const costPlanningViewColumns = [
    {
        dataField: 'name',
        caption: 'Подразделение',
        dataType: 'string',
        width: '200px',
        allowEditing: false
    }, {
        dataField: 'kod_spr_smet',
        caption: 'kod_spr_smet',
        dataType: 'number',
        width: '150px',
        visible: false,
        allowEditing: false
      }, {
        dataField: 'kod_direct',
        caption: 'kod_direct',
        dataType: 'number',
        width: '100px',
        visible: false,
        allowEditing: false
    },
    ...monthColumns,
    {
        dataField: 'pr_utv_year',
        caption: 'Утв.за год',
        dataType: 'boolean',
        width: '100px',
        allowEditing: false,
    }, {
        dataField: 'tep_el',
        caption: 'tep_el',
        dataType: 'number',
        width: '100px',
        visible: false,
        allowEditing: false
    }, {
        dataField: 'prizn',
        caption: 'prizn',
        dataType: 'number',
        width: '100px',
        visible: false,
        allowEditing: false
    }, {
        dataField: 'kod_col',
        caption: 'kod_col',
        dataType: 'number',
        width: '100px',
        visible: false,
        allowEditing: false
    }
];

export const filialRadio = [
  { id: '1', name: 'Филиал 1' }, { id: '2', name: 'Филиал 2' },
  { id: '3', name: 'Филиал 3' }, { id: '4', name: 'Управление предприятия' }
];
export const energyTypeRadio = [
  { id: '0', name: 'Общая' }, { id: '1', name: 'Электричество' }, { id: '2', name: 'Тепло'}
];
export const plFactIdRadio = [{ id: '2', name: 'Общая' }, { id: '0', name: 'План' }, { id: '1', name: 'Факт' }];

export const plFactIdSelectBox = [{ id: '2', name: 'Нет' }, { id: '0', name: 'План' }, { id: '1', name: 'Факт' }];

const columnSumPattern = (dataField, caption) => {
  return [{
    dataField: dataField,
    caption: caption,
    dataType: 'number',
    width: '120px',
    format: '###,###,###,###,##0',
  }]
};

export function getResultColumns({ plFactId, mode }) {
  const defaultColumns = [{
    dataField: 'name',
    caption: mode === '1' ? 'Наименование сметы' : 'Подразделение',
    width: '250px',
    fixed: true
  }, {
    dataField: 'kod_spr_smet',
    caption: 'kod_spr_smet',
    width: '150px',
    visible: false
  }, {
    dataField: 'kod_direct',
    caption: 'kod_direct',
    width: '150px',
    visible: false
  }];
  return (['0', '1'].includes(plFactId) && [...defaultColumns, ...columnsResultSmetMonths()]
    || plFactId === '2' && [...defaultColumns, ...columnsResultSmetCommon]);
}

function columnsResultSmetMonths() {
  const arr = [...monthColumns];
  arr.splice(12, 0,
    ...columnSumPattern('sum_4qv', '4 квартал'),
    ...columnSumPattern('sum_2pg', '2 полугодие'),
    ...columnSumPattern('sum_year', 'Год'));
  arr.splice(9, 0,
    ...columnSumPattern('sum_3qv', '3 квартал'),
    ...columnSumPattern('sum_9m', '9 мес.'));
  arr.splice(6, 0,
    ...columnSumPattern('sum_2qv', '2 квартал'),
    ...columnSumPattern('sum_1pg', '1 полугодие'));
  arr.splice(3, 0,
    ...columnSumPattern('sum_1qv', '1 квартал'));
  return arr;
}

export const columnsResultSmetCommon = [{
  dataField: 'sum_plan',
  caption: 'План',
  dataType: 'number',
  width: '150px',
  format: '###,###,###,###,##0',
}, {
  dataField: 'sum_fact',
  caption: 'Факт',
  dataType: 'number',
  width: '150px',
  format: '###,###,###,###,##0',
}, {
  dataField: 'sum_otklon',
  caption: 'Отклонение',
  dataType: 'number',
  width: '150px',
  format: '###,###,###,###,##0',
}, {
  dataField: 'proc',
  caption: 'Процент отклонения',
  dataType: 'string',
  width: '200px',
}, {
  dataField: 'otklon_description',
  caption: 'Пояснение к отклонению',
  dataType: 'string',
}, {
  dataField: '',
  caption: '',
  visible: true,
  minWidth: 0,
  showInColumnChooser: false,
  allowEditing: false,
}];

export async function getResultNdColumns(plFactId, period) {
  const defaultColumns = [{
    dataField: 'name',
    caption: 'Наименование сметы',
    width: '250px',
  }, {
    dataField: 'kod_spr_smet',
    caption: 'kod_spr_smet',
    width: '150px',
    visible: false
  }, {
    dataField: 'kod_direct',
    caption: 'kod_direct',
    width: '150px',
    visible: false
  }];
  if (plFactId === '2')
    return [...defaultColumns, ...columnsResultSmetCommon]
  else if (['0', '1'].includes(plFactId)) {
    const sumAll = {
      dataField: 'sum_all',
      caption: plFactId === '0' ? 'План' : 'Факт',
      width: '200px',
      format: '###,###,###,###,##0'
    };
    const columns = await costEstimateColumnsNotMainAll({ period });
    return plFactId === '0' && [...defaultColumns, sumAll, ...columns]
      || plFactId === '1' && [...defaultColumns, sumAll, ...columns];
  }
}

export const getEstimatePlan = async (args) => {
  return getData({
    url: '/estimate/plan',
    uuid: '95901913-7217-4728-abf8-d8f2d58c0690',
    args,
  });
};

export const setEstimatePlan = async (args) => {
  return postData({
    url: '/estimate/plan',
    uuid: '47deb5d9-a623-4c14-b592-9faa08e295d9',
    args,
  });
};

export const getEstimateFact = async (args) => {
  return getData({
    url: '/estimate/fact',
    uuid: 'a875bb5e-a6a4-481b-80db-21bb9de9a904',
    args,
  });
};

export const setEstimateFact = async (args) => {
  return postData({
    url: '/estimate/fact',
    uuid: 'f97bf04b-606b-469a-96ab-37505d3d1c5e',
    args,
  });
};

export const costEstimateColumnsNotMainAll = async (args) => {
  return getData({
    url: '/estimate/columns',
    uuid: 'e0ecb520-9e4a-4052-b95b-563e8d2165f8',
    args,
    loadPanel: true,
  });
};

export const getSprSmetCombo = async (args) => {
  return getData({
    url: '/estimate/spr-smet-combo',
    uuid: '00f3c61d-858a-4684-96d5-2ee8c3714685',
    args,
  });
};

export const getSprDepartmentsCombo = async (args) => {
  return getData({
    url: '/estimate/spr-departments-combo',
    uuid: '985a1fc8-fbab-47ce-91e0-2320c282c21b',
    args,
  });
};

export const getEstimateAllPlan = async (args) => {
  return getData({
    url: '/estimate/all/plan',
    uuid: '76447879-97d7-4d08-81f9-f42b07538145',
    args,
  });
};

export const setEstimateAllPlan = async (args) => {
  return postData({
    url: '/estimate/all/plan',
    uuid: '5302ea17-4217-40a0-ae29-838dff26b1a7',
    args,
  });
};

export const getEstimateAllFact = async (args) => {
  return getData({
    url: '/estimate/all/fact',
    uuid: '199edadf-2904-4420-a8ee-ebed3ea4e609',
    args,
  });
};

export const setEstimateAllFact = async (args) => {
  return postData({
    url: '/estimate/all/fact',
    uuid: 'c8d28d87-25db-4a80-97e4-2879232921b4',
    args,
  });
};

export const getResultPlanFact = async (args) => {
  return getData({
    url: '/result/plan-fact',
    uuid: 'aa3dcc6d-d3f0-43a2-965f-1c52f6e8b34b',
    args,
  });
};

export const getResultNd = async (args) => {
  return getData({
    url: '/result/nd',
    uuid: 'fe52b872-a4d8-41b3-b931-82279305b0cb',
    args,
  });
};

export const setRecalculateResults = async (args) => {
  return postData({
    url: '/result/recalculate',
    uuid: '5f547f5c-2abd-4339-a2ab-8202f02e63b5',
    args
  })
};

export const getConfirmationResults = async (args) => {
  return getData({
    url: '/result/confirmation',
    uuid: 'a9fa8422-5763-4f23-aa0a-5fd6212f96dc',
    args
  })
};

export const setConfirmationResults = async (args) => {
  return postData({
    url: '/result/confirmation',
    uuid: 'c83b5cac-2f52-4a9a-8e32-fbf830eadced',
    args
  })
};
